



import React from "react";
import * as yup from "yup";
import { useEffect, useState } from "react";
// import { getDocument, getOneApplicationDetail } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
// import PdfLoader from "../pdfloader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PdfLoaderModal from "../pages/pdfloader";
import SingleDocumentView from "../pages/pdfloader/SingleDocumentView";
import { getApplicationButtons, getDocument, getEsignVerification, getOneApplicationDetail, submitApproveRejectApplication } from "../auth/services/privateapicalling";
import ApplicationTimelineModal from "./ApplicationTimeLineModal";
import MultiSelectCheckbox from "./MultiSelectCheckbox";
// import PdfLoaderModal from "../pdfloader";
// import SingleDocumentView from "../pdfloader/SingleDocumentView";
import { docOptions } from "./Constants";
import {fieldsOptions} from "./Constants"
import ApproveUnsigned from "./ApproveUnsigned";
import SingleView from "../pages/pdfloader/Singleview";
import SingleView1 from "../pages/pdfloader/Singleview1";
import { ToastContainer,toast } from "react-toastify";

interface ApplicationDetails {
  
applicantName: string;

  registeredWithAPMC: string;
  
licenseType: string;
appStatusLevel: string;
 
}

interface AddressData {
  at: string;
  post: string;
  taluka: string;
  district: string;
}
interface UserAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  panCardNo: string;
  electionCardNo: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Representative {
  id: number;
  name: string;
  age: number;
  address: string;
}
interface Director {
  id: number;
  name: string;
  age: number;
  address: string;
}

interface Address {
  at: string;
  taluka: string;
  district: string;
}

interface Document {
  docId: string;
  docName: string;
  fileName: string;
}

interface ApplicationDetails {
  departmentId: string;
  applicantName: string;
  currAddress: Address[];
  perAddress: Address[];
  regOffAddress: Address[];
  panCardNo: string;
  electionCardNo: string;
  regEmailId: string;
  mobileNo: string;
  representatives: any[];
  firmRepresentatives: any[];
  entityName:string;
  entityRegistrationNo:string;
  entityGstNo:string;
  entityType:string;
  entityPanNo:string;
  entityFpoNo:string;
  guarantorDetails:any[];
  garantorDeclaration?: any;
  applicationId: string;
  createdAt: string;
  docs: Document[];
  department: any;
  appStatusLevel: string;
  status: string;
  partnerDetails:any[];
  bankDetails:any[];
}



const PreviewApplication: React.FC = () => {
  const [application, setApplication] = useState<ApplicationDetails | null>(
    null
  );

  const [addressData, setAddressData] = useState<AddressData | null>(null);
const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [comment , setComment] = useState<string>("");
  // const [status , setStatus] = useState<string>("");
  // const [appStatusLevel , setAppStatusLevel] = useState<string>("");
  const [role , setRole] = useState<string>("");
  const [buttonData , setButtonData] = useState<any[]>([]);
  const [transaction , setTransaction] = useState<any[]>([])
  const [docs , setDocs] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const[submitLoading , setSubmitLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [errorr, setErrorr] = useState<{[key: string] : string}>(null);
  const language = useSelector((state:any)=>state.auth.language);
  const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>({});
  const [rejectedDocName , setRejectedDocName] = useState<any[]>([])
  const [rejectedFields , setRejectedFields] = useState< any[]>([]);
  const [fieldComments, setFieldComments] = useState<{ [key: string]: string }>({}); 
  const [isChecked, setIsChecked] = useState<boolean>(false);
    const [err , setErr] = useState<{ [key: string]: string }>({});
    const [commentErrors, setCommentErrors] = useState<{ [key: string]: string }>({});
    const [FieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});
    const[license, setLicense] = useState<boolean>(false);
 const [htmlContent, setHtmlContent] = useState<string>("");

  
  

  const token = useSelector((state: any) => state.auth.token);
  const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
  
  const location = useLocation();
  const applicationId = location.state?.applicationId;

    const today = new Date();
  const currentYear = today.getFullYear();
  const july31 = new Date(currentYear, 6, 31); // July is month 6 (0-indexed)
  const endYear = today <= july31 ? currentYear - 1 : currentYear;
  
  const fiscalYears = [];
  for (let i = 0; i < 3; i++) {
    const fyEnd = endYear - i;
    const fyStart = fyEnd - 1;
    fiscalYears.push(`FY ${fyStart}-${fyEnd}`);
  }
  
  const updatedDocs = docOptions.map((field) => {
   
    if (field.value === "itReturns_1") {
      return { ...field, label: `IT Returns (${fiscalYears[0]})` };
    } else if (field.value === "itReturns_2") {
      return { ...field, label: `IT Returns (${fiscalYears[1]})` };
    } else if (field.value === "itReturns_3") {
      return { ...field, label: `IT Returns (${fiscalYears[2]})` };
    }
    return field;
  });

const filterDocOptions = updatedDocs.filter((doc) =>
  doc.value === "otherDoc" || 
  docs
    .map((docs) => docs.documentName)
    .includes(doc.value)
);


 const commentSchema = yup.object().shape({
    comment: yup.string()
      .required("Comment is required")
      .test(
        "min-words",
        "Comment must be at least 5 words",
        value => {
          if (!value) return false;
          return value.trim().split(/\s+/).length >= 5;
        }
      ),
     isChecked: yup
          .boolean()
          .oneOf([true], "Application approval is required")
  });

  const navigate = useNavigate();




const fetchApplicationDetails = async (appId:any) => {
  const role  =roleIdentifier === "panel"
  ? "panel"
  : roleIdentifier === "trader"
  ? "trader"
  : "department"
  try {
    //.log("fff")
    //.log('apppidddd',appId)
    const data = await getOneApplicationDetail(applicationId , token); 
    //.log('data',data)
    if(!data?.success){
      navigate("/error-404")
     }
    // const testdocID = "67cc7b9f5ce5a960d78030a3";
    // const docData = await getDocument(
    //   testdocID,
    //   token,
    //   role
    // );
    //.log('docccc' , docData);
    
    setApplication(data.data);
    setButtonData(data.data.buttonName);
    setRole(data.data?.role);
    setDocs(data.data.docs);
    //.log('docs uploaded by applicantt' , data.data.docs)

    //.log("transactionsss" , data?.data?.TraderAppTransaction)
    setTransaction(data?.data?.TraderAppTransaction)
    const app = data.data;
    const curradd = app.currAddress;
    //.log('ccc',curradd)
    setAddressData(curradd)
    

  } catch (err) {
    setError("Failed to load application details");
  } finally {
    setLoading(false);
    //.log("apppp" ,application)
  }
};
const fields= fieldsOptions.filter((field) =>
  field.allowRole?.includes(application?.entityType)
);

const handleSubmit = async (status:string , appStatusLevel:string) => {
  // Ensure state values are not empty before proceeding
  if (!status || !appStatusLevel && !applicationId) {
    toast.error("Status not found");
    return;
  }
 if(!license && application?.appStatusLevel == "clerkAfterApproveAction" && roleIdentifier == "JC")
 {toast.error("Please upload license document");
  return;
 }
  const errors: { [key: string]: string } = {};

  // Check for minimum 5 words in comments for rejected documents
  rejectedDocName.forEach((doc) => {
    const comment = fieldComments[doc.documentName];
    if (!comment || comment.trim() === "") {
      errors[doc.documentName] = "Comment is required.";
    } else if (comment.trim().split(/\s+/).length < 5) {
      errors[doc.documentName] = "Comment must be at least 5 words.";
    }
  });

  // Check for minimum 5 words in comments for rejected fields
  const missingComments = rejectedFields.filter(
    (fieldKey) => {
      const comment = fieldComments[fieldKey];
      return !comment || comment.trim() === "" || comment.trim().split(/\s+/).length < 5;
    }
  );

  if (missingComments.length > 0 || Object.keys(errors).length > 0) {
    // Set errors for missing or short comments
    missingComments.forEach((fieldKey) => {
      const comment = fieldComments[fieldKey];
      setCommentErrors((prevErrors) => ({
        ...prevErrors,
        [fieldKey]: !comment || comment.trim() === "" ? "Comment is required." : "Comment must be at least 5 words.",
      }));
    });

    // Set errors for rejected documents
    rejectedDocName.forEach((doc) => {
      const comment = fieldComments[doc.documentName];
      if (!comment || comment.trim() === "") {
        errors[doc.documentName] = "Comment is required.";
      } else if (comment.trim().split(/\s+/).length < 5) {
        errors[doc.documentName] = "Comment must be at least 5 words.";
      }
    });

    // Update the comment errors state
    setCommentErrors((prevErrors) => ({
      ...prevErrors,
      ...errors,
    }));

    // alert("Please provide comments for all selected fields.");
    return null; // Return early after setting errors for both
  }

  setCommentErrors({});

  const formData = {
    comment:comment,
    status:status,
    appStatusLevel:appStatusLevel,
    applicationId:applicationId,
    reSubmittedDocs:[],
    reSubmittedFields:[],
    rejectedDocName:rejectedDocName,
    rejectedFieldName:rejectedFields
  }

  try {

    setError("");

    let isvalid = true;
    if((roleIdentifier == "JC" || roleIdentifier=="COM" || roleIdentifier=="Dr" ) && (application.status == "pending" || application.status == "resubmission"  ) && (status !="reject"))
    {
      (formData as any).isChecked = isChecked;
    }
    
    
    if(
      (application?.appStatusLevel === "clerkAfterRejectionAction" && roleIdentifier === "JC") 
    )
    {
   
 

      if(formData.rejectedFieldName.length==0 && formData.rejectedDocName.length == 0)
      {
      
        
        isvalid=false 
        const err = {
          requery: 'Raise Query is required'
        }
        setErr(err)
        return;

      }
      else{
        isvalid=true
      }

    }
    
    const cc = await commentSchema.validate(formData ,  { abortEarly: false });


     if(isvalid)
     {
          const submitData = await submitApproveRejectApplication(formData, token);


    if (submitData.success) {
      if(submitData.data.status==="reject"){
        toast.warn("Raised Query Successfully!");
      }
        
      else{
        toast.success("Form submitted successfully!");
      }
     
      setButtonData([])
      fetchApplicationDetails(applicationId);
          setTimeout(() => {
       navigate('/application-pending')
        }, 1000);
     

    } else {
      toast.error("Submission failed, please try again.");
    }
     }    

  } catch (validationError) {
  if (validationError instanceof yup.ValidationError) {
    const errors = validationError.inner.reduce((acc, curr) => {
      acc[curr.path] = curr.message;
      return acc;
    }, {});
  
    setErrorr(errors); // assuming setErr is your error state setter
    return; // stop execution if validation fails
  } else {
   
    return;
  }
}
};

//.log('rejected doc name' , application)


const handleSelectionChange = (values: string[]) => {
  //.log('valueeesss' , values)
  setRejectedFields(values)
};

const handleCommentChange = (field: string, value: string) => {

  const updated = { ...fieldComments, [field]: value };
  setFieldComments(updated);

  setCommentErrors((prevErrors) => {
    const newErrors = { ...prevErrors };
    delete newErrors[field];
    return newErrors;
  });

  const combinedComment = Object.entries(updated)
    .map(([field, value]) => `${field}: ${value}`)
    .join(", ");
  setComment(combinedComment);
};

const handleDocsSelectionChange = (values: string[]) => {
  const lowerCasedValues = values.map((value) => value.trim().toLowerCase());

  const filteredDocs = docs.filter((doc) =>
    
    lowerCasedValues.includes(doc.documentName.trim().toLowerCase())
  );
  if(!docs.includes("otherDoc"))
 {  if (lowerCasedValues.includes("otherdoc")) {
    filteredDocs.push({
      docId:null,
      documentName: "otherDoc",
      fileName:""
    });
  }}

  // Remove duplicates by documentName
  const uniqueDocsMap = new Map();
  filteredDocs.forEach((doc) => {
    
    uniqueDocsMap.set(doc.documentName.trim().toLowerCase(), doc);
  });

  const uniqueDocs = Array.from(uniqueDocsMap.values());


  setRejectedDocName(uniqueDocs);
};

const handleVerify=async()=>{
  try{
    setSubmitLoading(true)
    const res = await getEsignVerification(applicationId , "TRADER",token)
        document.open();
    document.write(res);
    document.close();
  }catch(err){
    //.log('errrorrr' , err)
  }finally{
    setSubmitLoading(false)
  }
}
  useEffect(() => {
 
  
    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);

//.log('applicattionnnn' , application)

  return (
    <>
    <div>
       {/* {htmlContent && (
      <iframe
      
        srcDoc={htmlContent}
     sandbox="allow-forms allow-scripts allow-top-navigation"
  style={{ width: "100%", height: "100vh", border: "none" }}
      />
    )} */}
    
      <div className="cardhead page-wrapper">
          {submitLoading && (
             <div id="global-loader">
        <div className="page-loader"></div>
      </div>
              )}
        <div className="container-fluid content">
          {submitLoading && (
            <div className="loader-overlay">
              <div className="loader"></div>
              </div>
              )}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">{language.track_app} </h3>
              </div>
            </div>
          </div>
         
          {
            application?.appStatusLevel == "clerkAfterApproveAction" && roleIdentifier == "JC" && 
            <div>
              <div className="">
              <h3  className="text-danger fs-14 page-title">{language.dlusl}</h3>
              <ApproveUnsigned applicationId = {applicationId} setLicense={setLicense} />
            </div> 
            </div>
          }
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">{language.app_details}</h5>
                </div>
                   <div className="card-body">
                    {loading ? (
                      <p>Loading application details...</p>
                    ) : error ? (
                      <p className="text-danger">{error}</p>
                    ) : (
                      <div className="table-responsive">
                        {/* First Table */}
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th style={{ width: '25%' }}>{language.trader_name}</th>

                              <th style={{ width: '25%' }}>{language.register_with_apmc}</th>
                              <th style={{ width: '25%' }}>{language.period_of_license}</th>
                              <th style={{ width: '25%' }}>Application ID</th>
                            </tr>
                          </thead>
                          <tbody>
                            {application ? (
                              <tr>
                                <td style={{ width: '25%' }}>{application.applicantName}</td>

                                <td style={{ width: '25%' }}>
                                  {application.department?.apmcName ?? "N/A"}
                                </td>

                                <td style={{ width: '25%' }}>{application.licenseType}</td>
                                <td style={{ width: '25%' }}>{application.applicationId}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No application details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Second Table */}
                      </div>
                    )}
                  </div>
                    <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th style={{ width: '25%' }}>{language.mobile}</th>
                                <th style={{ width: '25%' }}>{language.email}</th>
                                <th style={{ width: '25%' }}>{language.pan_card_no}</th>
                                <th style={{ width: '25%' }}>{language.election_card_no}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.currAddress.length > 0 ? (
                                <tr>
                                  <td style={{ width: '25%' }}>{application?.mobileNo}</td>
                                  {/* <td>{userAddress.post}</td> */}
                                  <td style={{ width: '25%' }}>{application?.regEmailId}</td>
                                  <td style={{ width: '25%' }}>
                                    {application?.panCardNo}
                                  </td>
                                  <td style={{ width: '25%' }}>
                                    {application?.electionCardNo}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                <div>
                  <h5 className="mb-2">{language.current_address}:</h5>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-nowrap mb-0">
                        <thead>
                        <tr>
                            <th>{language.address}</th>
                            <th>{language.taluka}</th>
                            <th>{language.district}</th>
                          </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={3} className="text-center">Loading...</td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan={3} className="text-center text-danger">{error}</td>
                          </tr>
                        ) : !application ? (  // Check if application is null
                          <tr>
                            <td colSpan={3} className="text-center">No application details available.</td>
                          </tr>
                        ) :application?.currAddress?.length>0 ? (
                          <tr>
                            <td>{application?.currAddress[0]?.at}</td>
                            {/* <td>{userAddress.post}</td> */}
                            <td>{application?.currAddress[0]?.taluka}</td>
                            <td>{application?.currAddress[0]?.district}</td>
                          </tr>
                        ) 
                         : (
                          <tr>
                            <td colSpan={3} className="text-center">No address details available.</td>
                          </tr>
                        )}
                      </tbody>

                      </table>
                    </div>
                  </div>
                </div>

                <div>
                  <h5 className="mb-2"> {language.permanent_address}:</h5>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-nowrap mb-0">
                        <thead>
                        <tr>
                            <th>{language.address}</th>
                            <th>{language.taluka}</th>
                            <th>{language.district}</th>
                          </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={3} className="text-center">Loading...</td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan={3} className="text-center text-danger">{error}</td>
                          </tr>
                        ) : !application ? (  // Check if application is null
                          <tr>
                            <td colSpan={3} className="text-center">No application details available.</td>
                          </tr>
                        ) :application?.perAddress?.length>0 ? (
                          <tr>
                            <td>{application?.perAddress[0]?.at}</td>
                            {/* <td>{userAddress.post}</td> */}
                            <td>{application?.perAddress[0]?.taluka}</td>
                            <td>{application?.perAddress[0]?.district}</td>
                          </tr>
                        ) 
                         : (
                          <tr>
                            <td colSpan={3} className="text-center">No address details available.</td>
                          </tr>
                        )}
                      </tbody>

                      </table>
                    </div>
                  </div>
                </div>

                <div>
                  <h5 className="mb-2">{language.registered_office_address}:</h5>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-nowrap mb-0">
                        <thead>
                        <tr>
                            <th>{language.address}</th>
                            <th>{language.taluka}</th>
                            <th>{language.district}</th>
                          </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={3} className="text-center">Loading...</td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan={3} className="text-center text-danger">{error}</td>
                          </tr>
                        ) : !application ? (  // Check if application is null
                          <tr>
                            <td colSpan={3} className="text-center">No application details available.</td>
                          </tr>
                        ) :application?.regOffAddress?.length>0 ? (
                          <tr>
                            <td>{application?.regOffAddress[0].at}</td>
                            {/* <td>{userAddress.post}</td> */}
                            <td>{application?.regOffAddress[0]?.taluka}</td>
                            <td>{application?.regOffAddress[0]?.district}</td>
                          </tr>
                        ) 
                         : (
                          <tr>
                            <td colSpan={3} className="text-center">No address details available.</td>
                          </tr>
                        )}
                      </tbody>

                      </table>
                    </div>
                  </div>
                </div>
                     <div>
                      <h5 className="mb-2">{language.bankDetails}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.acct_no}</th>
                                <th>{language.ifsc_code}</th>
                                <th>{language.acct_type}</th>
                                  <th>{language.bank_name}</th>
                                <th>{language.branch_name}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available.
                                  </td>
                                </tr>
                              ) : application?.bankDetails?.length > 0 ? (
                                application?.bankDetails?.map(
                                  (rep, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{rep?.acct_no}</td>
                                      <td>{rep?.ifsc_code}</td>
                                      <td>{rep?.acct_type}</td>
                                      <td>{rep?.bank_name}</td>
                                      <td>{rep?.branch_name}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No Bank Details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  <div>
                    <h5 className="mb-2">{language.representative}:</h5>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>{language.name}</th>
                              <th>{language.age_in_year}</th>
                              <th>{language.address}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : !application ? (  // Check if application is null
                              <tr>
                                <td colSpan={3} className="text-center">No application details available.</td>
                              </tr>
                            ):
                            application?.representatives?.length > 0 ? (
                              application.representatives.map((rep, index) => (
                                <tr key={index}>
                                  <td>{index + 1}.</td>
                                  <td>{rep.name}</td>
                                  <td>{rep.age}</td>
                                  <td>{rep.address}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No representatives available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h5 className="mb-2">{language.firm}:</h5>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>{language.name}</th>
                              <th>{language.age_in_year}</th>
                              <th>{language.address}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">Loading...</td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td colSpan={4} className="text-center text-danger">{error}</td>
                              </tr>
                            ) : !application ? (  // Check if application is null
                              <tr>
                                <td colSpan={3} className="text-center">No application details available.</td>
                              </tr>
                            ):
                            application?.partnerDetails?.length > 0 ? (
                              application.partnerDetails.map((director, index) => (
                                <tr key={index}>
                                  <td>{index + 1}.</td>
                                  <td>{director.partnerName}</td>
                                  <td>{director.partnerAge}</td>
                                  <td>{director.partnerAddress}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">No firm/partner available.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                 

                { application?.entityType==="Firm"&& <div>
                      <h5 className="mb-2">{language.firmDetails}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Firm Name</th>
                                <th>Firm Registration No.</th>
                                <th>Firm Type</th>
                                <th>GST No.</th>
                                <th>Pan No</th>
                                <th>FPO  No</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : !application ? ( // Check if application is null
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No application details available. 
                                  </td>
                                </tr>
                              ) :  application?.entityName ? (
                               
                                      <tr>
                                      <td>{application?.entityName}</td>
                                      <td>{application?.entityRegistrationNo}</td>
                                      <td>{application?.entityType}</td>
                                      <td>{application?.entityGstNo}</td>
                                      <td>{application?.entityPanNo}</td>
                                      <td>{application?.entityFpoNo}</td>
                                    </tr>
                                  
                                
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No firm details available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>}
                <div>
                  <h5 className="mb-2">{language.enclosure}:</h5>
                  <div className="card-body">
                    <div className="table-responsive">
                      
                          <i className="text-2xl text-red-600 fa fa-file-pdf"></i>

                          <Link
                                    to="#"
                                    className="text-decoration-underline text-primary me-2"
                                    data-bs-toggle="modal" data-inert={true}
                                    data-bs-target="#pdf_loader_modal"
                                >
                                   {language.preview} 
                            </Link>
                            {/* <Link
                                    to="#"
                                    className="me-2"
                                    data-bs-toggle="modal" data-inert={true}
                                    data-bs-target="#edit_role"
                                >
                                    <i className="ti ti-edit" />
                            </Link> */}
                    </div>
                  </div>
                </div>
                  <div className="">
               <h5 className="mb-2">{language.guarantor}:</h5>
               <div className="card-body">
              <div className="table-responsive mb-4">
                <table className="table text-nowrap">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>{language.name}</th>
                      <th>{language.address}</th>
                      <th>{language.pan_card_no}</th>
                      <th>{language.photo}</th>
                      <th>{language.Signature}</th>
                      <th>{language.declarations}</th>
                    </tr>
                  </thead>
                  <tbody>
                  {application?.guarantorDetails?.map((guarantor, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{guarantor.name}</td>
                      <td>
                        <span className="badge bg-soft-primary">{guarantor.address}</span>
                      </td>
                      <td>{guarantor.panCardNo}</td>
                       {["photo", "signature", "declaration"].map((type) => (
                          <td key={type}>
                            {type === "declaration" ? (
                              // For declaration, use application.guarantorDeclaration
                              application?.garantorDeclaration ? (
                                <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-inert={true}
                                  data-bs-target="#double_modal"
                                  className="btn btn-primary align-items-center"
                                  onClick={() => {
                                    setSelectedDocId(application?.garantorDeclaration?.docId);
                                   
                                  }}
                                >
                                  {language.preview}
                                </Link>
                              ) : (
                                "No Attachment"
                              )
                            ) : (
                              // For photo or signature from docDetail
                              Array.isArray(guarantor.docDetail) &&
                              guarantor.docDetail.length > 0 ? (
                                (() => {
                                  const docType = type === "photo" ? `guarantorPhoto_${index + 1}` : `guarantorSignature_${index + 1}`;

                                  const doc = guarantor.docDetail.find((d) =>
                                    d.documentName?.includes(docType)
                                  );

                                  return doc ? (
                                    <Link
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-inert={true}
                                      data-bs-target="#double_modal"
                                      className="btn btn-primary align-items-center"
                                      onClick={() => {
                                        setSelectedDocId(doc.docId);
                                     
                                      }}
                                    >
                                      {language.preview}
                                    </Link>
                                  ) : (
                                    "No Attachment"
                                  );
                                })()
                              ) : (
                                "No Attachment"
                              )
                            )}
                          </td>
                        ))}
                    </tr>
                  )) || <tr><td colSpan={7}>No guarantor details available</td></tr>}
                  </tbody>

                </table>

              </div>
              <h4 className="mb-2">{language.fee} :</h4>
              <p className="mb-2">{language.fees}{application?.licenseType || null } {language.year} : {(application as any)?.paymentFees ?? null}</p>
            
               </div>
               { transaction && transaction.length>0 &&
              
              <Link
              to="#"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#comment_modal"
              className="d-flex btn btn-primary align-items-center w-25 mb-4"
              >
                  <i className="me-2 ti ti-file-description" />
                  {language.view_comment}
              </Link>     
               }
               

               {/* {(application?.appStatusLevel == "dclerkAfterRejectionAction" && roleIdentifier === "JC") ||
                                     (application?.appStatusLevel == "hoclerkAfterRejectionAction" && roleIdentifier == "HJC") &&
                                     (
                                       <div>
                                         <div className="mb-0">
                                           <h3 className="text-danger fs-15 page-title">
                                             {language.rej_da}
                                           </h3>
                                           <MultiSelectCheckbox
                                             Options={fieldsOptions}
                                             onChange={handleSelectionChange}
                                             docs={docs}
                                           />
                                           {rejectedFields && rejectedFields.length>0 && rejectedFields.map((fieldKey) => (
                                             <div key={fieldKey} className="mb-3">
                                               <label className="form-label">{language[fieldKey]} Comment</label>
                                               <input
                                                 type="text"
                                                 className="form-control"
                                                 value={fieldComments[fieldKey] || ""}
                                                 onChange={(e) => handleCommentChange(fieldKey, e.target.value)}
                                                 placeholder={`Enter comment for ${fieldKey}`}
                                               />
                                             </div>
                                           ))}
               
                                         </div>
                                       </div>
                                     )} */}

          {
            application?.appStatusLevel == "clerkAfterRejectionAction" && roleIdentifier == "JC" &&
            <div>
            <div className="mb-4">
              
              <h3  className="text-danger fs-12 page-title">{language.rej_da}</h3>
              <MultiSelectCheckbox Options={fields} onChange={handleSelectionChange} />
                 {rejectedFields && rejectedFields.length>0 && rejectedFields.map((fieldKey) => (
                  <div key={fieldKey} className="mb-3">
                    <label className="form-label">{language[fieldKey]} Comment (min 5 words)</label>
                    <input
                      type="text"
                      className={`form-control ${commentErrors[fieldKey] ? "is-invalid" : ""}`}
                      value={fieldComments[fieldKey] || ""}
                      onChange={(e) => handleCommentChange(fieldKey, e.target.value)}
                      placeholder={`Enter comment for ${language[fieldKey]}`}
                    />
                      {commentErrors[fieldKey] && (
                      <div className="invalid-feedback">
                        {commentErrors[fieldKey]}
                      </div>
                    )}
                  </div>
                ))}
            </div> 
            <div className="mb-4">
              <h3  className="text-danger fs-12 page-title">{language.rej_doc}</h3>
            
              <MultiSelectCheckbox Options={filterDocOptions} onChange={handleDocsSelectionChange} docs={docs} />
              {rejectedDocName && rejectedDocName.length>0 && rejectedDocName.map((fieldKey) => (
                  <div key={fieldKey} className="mb-3">
                    <label className="form-label">{language[fieldKey.documentName]} Comment (min 5 words)</label>
                    <input
                      type="text"
                      className={`form-control ${commentErrors[fieldKey.documentName] ? "is-invalid" : ""}`}
                      value={fieldComments[fieldKey.documentName] || ""}
                      onChange={(e) => handleCommentChange(fieldKey.documentName, e.target.value)}
                      placeholder={`Enter comment for ${language[fieldKey.documentName]}`}
                    />
                    {commentErrors[fieldKey.documentName] && (
                      <div className="invalid-feedback">
                        {commentErrors[fieldKey.documentName]}
                      </div>
                    )}
                  </div>
                  
                

                ))}
            </div> 
            {err.requery && (
                        <p style={{ color: "red" }}>{err.requery}</p>
                       )}
            {errorr?.comment && (
              <p style={{ color: "red" }}>{errorr?.comment}</p>
            )}
            </div>
             
          }

                      { ["JC" , "COM" , "Dr"].includes(roleIdentifier) && (application?.status === "pending" || application?.status === "resubmission") && <div className="mt-2">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="declaration"
                          className="form-check-input"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <label htmlFor="declaration" className="form-check-label fw-bold">
                          I have checked the application and it has been approved from my end
                        </label>
                      </div>
                   
                        {errorr?.isChecked && <p style={{ color: "red" }}>{errorr?.isChecked}</p>}
                    </div>}                     
               
                <div className="d-flex row justify-content-center">
                <div className="d-flex justify-content-between w-50">
                  
                 { buttonData && buttonData.length > 0 && buttonData[0].appStatusLevel != "licenseGranted" && role!=="" && (roleIdentifier == role) && 
                  <div className="row">
                   { !(["JC"].includes(role) && application.appStatusLevel=="clerkAfterRejectionAction") &&
                    <div>
                    <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment (min 5 words)"
                    name="currAt"
                    value={comment!=""? comment : ""} // Bind value to state
                    onChange={(e) => setComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    // maxLength={100}
                  />
                   {errorr?.comment && <div className="text-danger mb-2">{errorr?.comment}</div>}
                  </div>
                   }
                          {/* <button
                            
                            className={`btn  "btn-success"
                             h-10 w-70`}
                            onClick={() => handleVerify()}
                          >
                           verify
                          </button> */}
                      
                      <div className="d-flex gap-2">
                        {buttonData.map((button) => (
                          <button
                            key={button.status}
                            className={`btn ${
                              button.status === "reject"
                                ? "btn-danger"
                                :  button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                            } h-10 w-70`}
                            onClick={() => {
                              if(button.status === "approve" ){
                                handleVerify()
                              }else{
                              handleSubmit(button.status , button.appStatusLevel)}
                            }}
                          >
                            {button.buttonLabel}
                          </button>
                        ))}
                      </div>

                  </div>}
                  
                </div>
              </div>
            </div>
            
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PdfLoaderModal applicationId={applicationId} applicationType="trader" />
    <SingleView1 docId={selectedDocId}/>
    <ApplicationTimelineModal comments={transaction} />
    <ToastContainer autoClose={3000} position="top-right"/>
    </>

  );
};

export default PreviewApplication;

